export default {
  GET_DICTBYTYPE: '/api/common/dictionary/getDictByType',               // 下拉框初始化

  GET_NECBYTYPE: '/api/common/dictionary/getNecGroupType ',             // 下拉框初始化

  MESSAGE_LIST: '/api/pushMessage/listByType',                           // 消息列表

  MESSAGE_UNREADNUM: '/api/pushMessage/unReadNum',                       // 消息列表数量

  MESSAGE_UNREADNUM_Total: '/api/pushMessage/unReadTotal',              // 活动消息总数量

  MESSAGE_UNREADNUM_ALL: '/api/pushMessage/unReadAll',                 // 未读消息总数

  PUSHMESSAGE_READMESSAGE: '/api/pushMessage/readMessage'                 // 读消息
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/message.js